export interface FilterGroup {
    filters: Filter[];
}

export interface Filter {
    field: FilterField;
    value: string;
    conditionType: FilterConditionType;
}

export enum FilterField {
    ID = 'entity_id',
    SKU = 'sku',
    NAME = 'name',
    DECOR = 'decor',
    IDENTIFIER = 'identifier'
}

export enum FilterConditionType {
    EQUAL = 'eq',
    NOT_EQUAL = 'neq',
    LIKE = 'like',
    NOT_LIKE = 'nlike',
    IS = 'is',
    IN = 'in',
    NOT_IN = 'nin',
    NULL = 'null',
    NOT_NULL = 'notnull',
    MORE_OR_EQUAL = 'moreq',
    GREATER = 'gt',
    LESS = 'lt',
    GREATER_OR_EQUAL = 'gteq',
    LESS_OR_EQUAL = 'lteq',
    IN_SET = 'finset',
    FROM = 'from',
    TO = 'to'
}

export interface SortOrder {
    field: SortField;
    direction: SortDirection;
}

export enum SortField {
    SKU = 'sku',
    NAME = 'name',
    DECOR = 'decor',
    SORT_NUMBER = 'sort_number',
    PRICE = 'price',
    NEW = 'new',
    IDENTIFIER = 'identifier'
}

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}
